import React, {useState} from 'react'
import Logo from '../assets/5.jpg'
import {FaBars, FaTimes, FaGithub, FaLinkedin, FaTwitter, FaMedium} from 'react-icons/fa'
import {HiOutlineMail} from 'react-icons/hi'
import {Link} from 'react-scroll'

const Navbar = () => {
    const [nav, setNav] = useState(false)
    const handleClick = () => setNav(!nav)
  return (
    <div className='fixed w-full h-[80px] flex justify-between items-center px-4 bg-[#000000] text-gray-300 '>
        <div>
            <img style = {{width: '70px', border: '50%'}} src={Logo} alt="Logo" />
        </div>
        {/* Menu */}
        
            <ul className='hidden md:flex'>
                <li><Link to='home' smooth={true} duration={500} >Home</Link></li>
                <li><Link to='about' smooth={true} duration={500} >About</Link></li>
                <li><Link to='skills' smooth={true} duration={500} >Skills</Link></li>
                <li><Link to='work' smooth={true} duration={500} >Work</Link></li>
                <li><Link to='contact' smooth={true} duration={500} >Contact</Link></li>
            </ul>

        {/* Hamburger */}
        <div className= 'md:hidden z-10' onClick={handleClick}>
            {/* <FaBars /> */}
            {!nav ? <FaBars />: <FaTimes />}
        </div>

        {/* Mobile menu */}
        <ul className={!nav ? 'hidden' : 'absolute top-0 left-0 w-full h-screen bg-[#000000] flex flex-col justify-center items-center'}>
                <li className='py-6 text-4xl'><Link onClick={handleClick} to='home' smooth={true} duration={500} >Home</Link></li>
                <li className='py-6 text-4xl'><Link onClick={handleClick} to='about' smooth={true} duration={500} >About</Link></li>
                <li className='py-6 text-4xl'><Link onClick={handleClick} to='skills' smooth={true} duration={500} >Skills</Link></li>
                <li className='py-6 text-4xl'><Link onClick={handleClick} to='work' smooth={true} duration={500} >Work</Link></li>
                <li className='py-6 text-4xl'><Link onClick={handleClick} to='contact' smooth={true} duration={500} >Contact</Link></li>
        </ul>

        {/* social icons */}
        <div className='hidden lg:flex fixed flex-col top-[35%] left-0'>
            <ul>
                <li className='w-[160px] h-[60px] flex-col justify-between items-center'>
                    <a className='flex justify-between items-center w-full text-gray-300 ml-[-100px] hover:ml-[-10px] m-1 p-2 duration-500 bg-blue-600' href="https://www.linkedin.com/in/aman-singh-9b36bb185/">LinkedIn <FaLinkedin size={30}/></a>
                    <a className='flex justify-between items-center w-full text-gray-300 ml-[-100px] hover:ml-[-10px] m-1 p-2 duration-500 bg-black-600' href="https://github.com/Lethalcode69">Github <FaGithub size={30}/></a>
                    <a className='flex justify-between items-center w-full text-gray-300 ml-[-100px] hover:ml-[-10px] m-1 p-2 duration-500 bg-gray-600' href="https://medium.com/@feb19aman">Medium <FaMedium size={30}/></a>
                    <a className='flex justify-between items-center w-full text-gray-300 ml-[-100px] hover:ml-[-10px] m-1 p-2 duration-500 bg-sky-600' href="https://twitter.com/BadKarmamegm">Twitter <FaTwitter size={30}/></a>
                    <a className='flex justify-between items-center w-full text-gray-300 ml-[-100px] hover:ml-[-10px] m-1 p-2 duration-500 bg-purple-600' href="https://in.mail.yahoo.com">MailID<HiOutlineMail size={30}/></a>
                    {/* <a className='flex justify-between items-center w-full text-gray-300 ml-[-85px] hover:ml-[-10px] duration-500 bg--600' href=""><BsFillPersonLinesFill/></a> */}
                </li>
            </ul>
        </div>
    </div>
    
  )
}

export default Navbar